module.exports = __webpack_public_path__ + "images/thumbs-up-old8a7f46359e677f6c9aff81f099ef6c84.svg";